import React from "react";

import { Check } from "../../../../presentation/pages/mobile/Check";
import { makeDbListReceipt } from "../../usecases/list-receipts-factory";

export const makeCheck = () => {
  return <Check listReceipts={makeDbListReceipt()} />;
};
